import axios from "axios";
import { ErrorToast, SuccessToast } from "../components/toastify";
import HandleLogout from "../hooks/handleLogout";
import {
  isRegistrationPaymentPending,
  saveOperatorSession,
} from "../helpers/operatorSession";
import { setUserLoginStatus } from "../store/userStatus";

const getApiUrl = (endpoint) => {
  const baseUrl = (process.env.REACT_APP_API_URL || "").trim().replace(/\/+$/, "");
  const cleanEndpoint = String(endpoint || "").replace(/^\/+/, "");
  return `${baseUrl}/${cleanEndpoint}`;
};

const VerifyOtp = async (otp, navigate, dispatch) => {
  const otpToken = localStorage.getItem("dwt-tok-otp");
  const endpoint = getApiUrl("verify/otp");

  console.log("[OTP_DEBUG] verifyOtp start", {
    endpoint,
    otp,
    otpLength: String(otp || "").length,
    hasOtpToken: Boolean(otpToken),
    tokenPreview: otpToken ? `${otpToken.slice(0, 16)}...` : null,
  });

  if (!otpToken) {
    ErrorToast("OTP session expired. Please login again.");
    navigate("/login");
    return null;
  }

  const successRes = await axios
    .post(
      endpoint,
      { otp },
      {
        headers: {
          Authorization: `Bearer ${otpToken}`,
        },
      },
    )
    .catch((err) => err?.response || {
      status: 0,
      data: { message: err?.message || "Network error. Please try again." },
    });

  console.log("[OTP_DEBUG] verifyOtp response", {
    status: successRes?.status,
    data: successRes?.data,
  });

  if (successRes.status === 200) {
    dispatch(setUserLoginStatus(true));
    localStorage.removeItem("dwt-tok-otp");
    saveOperatorSession(successRes.data.data);
    SuccessToast("OTP verification successful");
    if (
      isRegistrationPaymentPending(
        successRes?.data?.data?.registration_payment_status,
      )
    ) {
      navigate("/registration-payment");
      ErrorToast("Registration payment is pending. Complete payment to continue.");
      return;
    }
    navigate("/dashboard/home");
    SuccessToast("Welcome Back!");
  } else {
    if (successRes?.status === 401) HandleLogout();
    ErrorToast(successRes?.data?.message || "OTP verification failed.");
    return null;
  }
};

export default VerifyOtp;
